import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Header from './Header';
import BottomNavigation from './BottomNavigation';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  showBackButton?: boolean;
  onBack?: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, title, showBackButton, onBack }) => {
  const { themeClasses } = useTheme();

  return (
    <div className={`min-h-screen ${themeClasses.background}`}>
      <Header title={title} showBackButton={showBackButton} onBack={onBack} />
      <div className="pt-24 pb-20">
        {children}
      </div>
      <BottomNavigation />
    </div>
  );
};

export default Layout;

